import React, {PureComponent} from 'react';
import injectSheet from 'react-jss'
import cn from 'classnames'
import {connect} from "react-redux"
import {getPreviewToken} from "../selectors/content";
import {setPreviewToken} from "../actions/content"
import {canUseDom} from "../utils/dom"

import SVGSymbol from "./SVGSymbol"
import tick from '../img/icons/tick.svg'
import {TimelineMax} from "gsap"
import {getApiUrl} from '../config'

class PreviewLink extends PureComponent {

    componentDidMount() {

        const {classes, handleSetPreviewToken} = this.props;

        if(! canUseDom ) return;
        var token = document.cookie.match(/\bio\.prismic\.preview=([^;]*)\b/);
        if(token && token[1]) {
            handleSetPreviewToken(token[1]);

            // This message comes from the prismic iframe, see http://static.cdn.prismic.io/prismic.js for more details
            window.addEventListener('message', function (event) {
                const message = event.data;
                switch (message.type) {

                    case 'io.prismic.display':
                        var fframe = document.getElementById("io-prismic-toolbar");
                        fframe.className = classes.prismicFrameToolbar;
                        break;

                    case 'io.prismic.toggle':
                        var frame = document.getElementById("io-prismic-toolbar");
                        if (message.data === 'detail') {
                            frame.className = "";
                        } else {
                            frame.className = classes.prismicFrameToolbar;
                        }
                        break;
                    default:
                        break;
                }
            });
        }
    }


    copyPreviewLink = () => {

        const {classes} = this.props;
        var copyTextarea = document.querySelector('.' + classes.previewLinkTextArea);
        copyTextarea.style.display = 'inherit';
        copyTextarea.select();

        try {
            var successful = document.execCommand('copy');
            if(!successful) {
                prompt("Press Ctrl+C to copy link to clipboard", copyTextarea.value)
            }
            else {

                const time = 0.2;
                var tl = new TimelineMax({delay:0.2});
                    tl.to(this._copyPreviewLinkRef, time, {y:'-100%'})
                        .to(this._copiedPreviewLinkRef, time, {y:'-100%'}, '-=' + time)
                        .to(this._copyPreviewLinkRef, time, {y:'0%'}, '+=2')
                        .to(this._copiedPreviewLinkRef, time, {y:'0%'}, '-=' + time)

            }
        } catch (err) {
            prompt("Press Ctrl+C to copy link to clipboard", copyTextarea.value)
        }

        copyTextarea.style.display = 'none';
    }

    setCopyPreviewLinkRef = (ref) => this._copyPreviewLinkRef = ref;
    setCopiedPreviewLinkRef = (ref) => this._copiedPreviewLinkRef = ref;

    getPreviewLink = () => {
        const {previewToken} = this.props;
        return `${window.location.href.replace(window.location.pathname, '')}${getApiUrl()}/preview?token=${encodeURIComponent(previewToken)}`;
    }

    render() {
        const {classes, previewToken} = this.props;
        if(!previewToken) return null;

        return <div className={classes.previewLinkContainer} >
                        <a className={classes.previewLink} onClick={this.copyPreviewLink} ref={this.setCopyPreviewLinkRef}>Copy Preview Link</a>
                        <a className={cn(classes.previewLink, "copied")} ref={this.setCopiedPreviewLinkRef}>Copied to Clipboard <SVGSymbol icon={tick} className={classes.tick}></SVGSymbol></a>
                        <textarea className={classes.previewLinkTextArea} defaultValue={this.getPreviewLink()}></textarea>
                    </div>;
    }
}

function mapStateToProps(state) {
    return {
        previewToken: getPreviewToken(state)
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        handleSetPreviewToken: (token) => {
            dispatch( setPreviewToken(token) );
        },
    }
}

export default injectSheet((theme) => (
    {
        prismicFrameToolbar: {
            transform: 'scale(0.7)',
            marginRight: -80
        },
        previewLinkContainer: {
            position: 'fixed',
            bottom: 5,
            right: 0,
            height: 22,
            overflow: 'hidden'
        },
        previewLinkTextArea: {
            display: 'none'
        },
        previewLink: {
            fontSize: '12px',
            fontWeight: 'bold',
            marginRight: 10,
            display: 'block',
            textAlign: 'right',
            alignItems: 'center',
            //transition: 'transform 0.3s',
            '&.copied': {
                color: 'green',
                //transform: 'translate(0, -100px)',
            }
        },
        tick: {
            width: 14,
            height: 14,
            marginLeft: 2,
            verticalAlign: 'middle',
            position: 'relative',
            top: '-.1em'
        }
    })
)(connect(mapStateToProps, mapDispatchToProps)(PreviewLink));



// WEBPACK FOOTER //
// ./src/components/PreviewLink.js